import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DELETE_ACCOUNT: "Slett konto",
      YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_IS_BEING_PROCESSED:
        "Din forespørsel om å slette kontoen din er mottatt",
      WE_WILL_CONTACT_YOU_WHEN_REQUEST_IS_PROCESSED:
        "Du vil motta en bekreftelse fra oss når sletteprosessen har startet, normalt innen 24 timer. Takk for at du har vært kunde hos oss, og vi håper å se deg igjen i fremtiden! I mellomtiden vil kontoen din være låst.",
      I_UNDERSTAND: "Jeg forstår",
    },
    se: {
      DELETE_ACCOUNT: "Radera konto",
      YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_IS_BEING_PROCESSED:
        "Din begäran om att radera ditt konto har mottagits",
      WE_WILL_CONTACT_YOU_WHEN_REQUEST_IS_PROCESSED:
        "Du mottar en bekräftelse från oss när raderingsprocessen har påbörjats, vanligtvis inom 24 timmar. Tack för att varit kund hos oss, vi hoppas att få välkomna dig tillbaka igen i framtiden! Under tiden är ditt konto låst.",
      I_UNDERSTAND: "Jeg forstår",
    },
    dk: {
      DELETE_ACCOUNT: "Slet konto",
      YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_IS_BEING_PROCESSED:
        "Din anmodning om at slette din konto er modtaget",
      WE_WILL_CONTACT_YOU_WHEN_REQUEST_IS_PROCESSED:
        "Du vil modtage en bekræftelse fra os, når sletningsprocessen er startet - normalt inden for 24 timer. Mange tak for denne gang. Vi håber at se dig igen på et senere tidspunkt.  I mellemtiden vil din konto være låst.",
      I_UNDERSTAND: "Jeg forstår",
    },
  } as const
)[language];
